export enum AnalysisType {
    TRENDS = 'trends',
    WORST_PERFORMING_VESSELS = 'worstPerformingLocations',
    SCORECARD = 'assetStatus',
    BENCHMARK = 'benchmark',
    TARGET = 'target',
}
